class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      //Ak custom code
      const item = this.closest('.cart-item').getAttribute('data-timstamp');
      //End Ak custom code
      
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);

      //Ak custom code
        if(item){
          setTimeout(function() {
        //   console.log('hii')
          var arritem = [];
          const length_item =  $('#CartDrawer cart-drawer-items .cart-items .cart-item.bundle-sub-pro[data-timstamp="'+item+'"]').length;
          // console.log(length_item);
          var toupdate = "";
          if(length_item > 0){
          $('#CartDrawer cart-drawer-items .cart-items .cart-item.bundle-sub-pro[data-timstamp="'+item+'"]').each(function(select_index){
            var index = $(this).attr('data-line');
            var var_id = $(this).attr('data-id');
            var key = $(this).attr('data-item-key');
            toupdate += "updates[" + key + "]=0&"
            // console.log(select_index);
            if (select_index === length_item - 1) {
                      // var paramsup = {
                      //     type: "POST",
                      //     url: "/cart/update.js",
                      //     data: toupdate.substring(0, toupdate.length - 1),
                      //     success: function(content) {                            
                      //         $.ajax({
                      //             url: window.location.href,
                      //             method: "GET",
                      //             dataType: "html",
                      //             success: function(htmlContent) {
                      //                 let doc = new DOMParser().parseFromString(htmlContent, "text/html");
                      //                 let cartDrawerElement = doc.querySelector("#CartDrawer .drawer__inner");
                      //                 cartDrawerElement && ($("#CartDrawer .drawer__inner").replaceWith(cartDrawerElement.outerHTML))
                      //               // $('.m-cart-drawer--inner').removeClass('al-loading-bar loading al-loading-overlay overlay-show');
                      //                var items = document.querySelector('cart-drawer cart-drawer-items table.cart-items');
                      //               if(items){
                      //                 $("body").addClass("overflow-hidden"), $("cart-drawer.drawer").removeClass("is-empty"), $("cart-drawer.drawer").addClass("active");
                      //               }else{
                      //                  $("cart-drawer.drawer").addClass("is-empty"), $("cart-drawer.drawer").addClass("active");
                      //               }
                      //                 jQuery.getJSON('/cart.js', function(cart) {
                      //                  if(cart.item_count > 0){
                      //                     if($(".cart-count-bubble").length > 0)
                      //                     {
                      //                       $(".cart-count-bubble span:first").html(cart.item_count);
                      //                       $(".cart-count-bubble span.visually-hidden").html(cart.item_count+" items");
                      //                     }
                      //                       else
                      //                     {
                      //                       var html = "<div class='cart-count-bubble'><span aria-hidden='true'>"+ cart.item_count +"</span><span class='visually-hidden'>"+ cart.item_coun +"items</span></div>";
                      //                       // $(".header__icon--cart svg path").eq(3).remove();
                      //                       $(html).insertAfter(".header__icon--cart span");
                      //                     }
                      //                  }else{
                      //                    $(".cart-count-bubble").hide();
                      //                  }
                      //                 // });
                      //                 // $("body").addClass("overflow-hidden"), $("cart-drawer.drawer").removeClass("is-empty"), $("cart-drawer.drawer").addClass("active");
                      //             },
                      //             error: function(error) {
                      //                 console.error("Error fetching and modifying HTML:", error)
                      //             }
                      //         });
                      //     },
                      //     error: function() {}
                      // };
                      // $.ajax(paramsup)

                    var paramsup = {
                      type: "POST",
                      url: "/cart/update.js",
                      data: toupdate.substring(0, toupdate.length - 1),
                      success: function () {
                        $.ajax({
                          url: window.location.href,
                          method: "GET",
                          dataType: "html",
                          success: function (htmlContent) {
                            let doc = new DOMParser().parseFromString(htmlContent, "text/html");
                            let cartDrawerElement = doc.querySelector("#CartDrawer .drawer__inner");
                    
                            if (cartDrawerElement) {
                              $("#CartDrawer .drawer__inner").replaceWith(cartDrawerElement.outerHTML);
                    
                              let items = document.querySelector("cart-drawer cart-drawer-items table.cart-items");
                              if (items) {
                                $("body").addClass("overflow-hidden");
                                $("cart-drawer.drawer").removeClass("is-empty").addClass("active");
                              } else {
                                $("cart-drawer.drawer").addClass("is-empty active");
                              }
                            }
                    
                            // Update cart bubble
                            jQuery.getJSON("/cart.js", function (cart) {
                              if (cart.item_count > 0) {
                                let cartCountBubble = $(".cart-count-bubble");
                                if (cartCountBubble.length > 0) {
                                  cartCountBubble.find("span:first").html(cart.item_count);
                                  cartCountBubble.find("span.visually-hidden").html(`${cart.item_count} items`);
                                } else {
                                  let html = `
                                    <div class='cart-count-bubble'>
                                      <span aria-hidden='true'>${cart.item_count}</span>
                                      <span class='visually-hidden'>${cart.item_count} items</span>
                                    </div>`;
                                  $(html).insertAfter(".header__icon--cart span");
                                }
                              } else {
                                $(".cart-count-bubble").hide();
                              }
                            });
                          },
                          error: function (error) {
                            console.error("Error fetching and modifying HTML:", error);
                          },
                        });
                      },
                      error: function (error) {
                        console.error("Error updating cart:", error);
                      },
                    };
                    
                    $.ajax(paramsup);

              }
            
          });
          }
          }, 1500);
        }
      //End Ak custom code
      
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    jQuery.getJSON('/cart.js', function(cart) {
      // now have access to Shopify cart object
      // alert('There are now ' + cart.item_count + ' items in the cart.');
       if(cart.item_count == 1){
          $('.free_gift_msg_main').css('display','block');
        }else{
           $('.free_gift_msg_main').css('display','none');
        }
    } );
    
    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch('/cart?section_id=main-cart-items')
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = 
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = 
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});

        // console.log(parsedState.item_count);
        
        if(parsedState.item_count == 1){
          $('.free_gift_msg_main').css('display','block');
        }else{
           $('.free_gift_msg_main').css('display','none');
        }
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};
